import React from "react";
import { Table } from "antd";
import { DatatableProps } from "../../data/interface"; // Ensure correct path

interface ExtendedDatatableProps extends DatatableProps {
  rowSelection?: {
    selectedRowKeys: number[];
    onChange: (selectedKeys: any[]) => void;
  };
}

const Datatable: React.FC<ExtendedDatatableProps> = ({ columns, dataSource, rowSelection }) => {
  return (
    <Table
      className="table datanew dataTable no-footer"
      rowSelection={rowSelection} 
      columns={columns}
      dataSource={dataSource}
      // pagination={false}
    />
  );
};

export default Datatable;
